export const RECOMMENDATION_MESSAGES = [
  {
    code: 'OPTION_TT_CAUSE',
    message:
      'de protéger ma famille en transmettant un capital sécurisé en cas de décès'
  },
  {
    code: 'OPTION_ACC',
    message:
      'de protéger ma famille en transmettant un capital sécurisé en cas de décès'
  },
  {
    code: 'OPTION_INCAP',
    message:
      'de maintenir mes revenus en cas de maladie ou d\'accident, grâce au versement d\'indemnités journalières'
  },
  {
    code: 'OPTION_FR_GEN',
    message:
      'd\'assurer la prise en charge de mes charges professionnelles fixes en cas d\'arrêt de travail'
  },
  {
    code: 'OPTION_INVAL',
    message:
      'de maintenir mes revenus en cas de maladie ou d\'accident, grâce au versement d\'une rente invalidité'
  }
];

export const RECOMMENDATION_INTRO_MESSAGE =
  'Mon conseiller me recommande de souscrire à ce produit car ses garanties me permettent :';
